import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=1024c0b5&scoped=true&"
import script from "./AnnouncementList.vue?vue&type=script&lang=js&"
export * from "./AnnouncementList.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementList.vue?vue&type=style&index=0&id=1024c0b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1024c0b5",
  null
  
)

export default component.exports